import { render, staticRenderFns } from "./crearSeleccionSimple.vue?vue&type=template&id=009a56bb"
import script from "./crearSeleccionSimple.vue?vue&type=script&lang=js"
export * from "./crearSeleccionSimple.vue?vue&type=script&lang=js"
import style0 from "./crearSeleccionSimple.vue?vue&type=style&index=0&id=009a56bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports